import { EntityType } from '@frontend/common';
import { FormattedMessage } from 'react-intl';

import placeholder from '../../../assets/images/image-placeholder.png';
import { useImageContainer } from './image-container.controller';

const ID = 'image-container';

export interface ImageContainerProps<T> {
    entity: T;
    entity_type: EntityType;
}

export const ImageContainer = <T,>(props: ImageContainerProps<T>): React.ReactNode => {
    const viewProps = useImageContainer(props);
    return (
        <div
            id={ID}
            className='bg-background-surface border-border-default inline-flex w-64 items-center justify-start gap-2.5 self-stretch rounded-xl border p-4'>
            {viewProps.image === undefined ? (
                <span className='placeholder-glow'>
                    <span className='placeholder h-40 w-40'>
                        <FormattedMessage
                            id='vendingProductImage.imageLoading'
                            defaultMessage='Loading'
                            description='Message displayed to replace image while loading'
                        />
                    </span>
                </span>
            ) : (
                <img
                    className='h-56 w-full object-contain'
                    src={viewProps.image || placeholder}
                    alt={'entity-image'}
                />
            )}
        </div>
    );
};
